type PrivacyElements = {
  banner: HTMLElement;
  dialog: HTMLDialogElement;
  trigger: HTMLElement;
};

const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function createPrivacyController(elements: PrivacyElements) {
  let returnFocus: HTMLElement | null = null;
  const close = () => {
    elements.dialog.close();
    returnFocus?.focus();
  };
  const open = (trigger = elements.trigger) => {
    returnFocus = trigger;
    if (!elements.dialog.open) elements.dialog.showModal();
    elements.dialog.querySelector<HTMLElement>(focusableSelector)?.focus();
  };
  elements.dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  elements.dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const items = [...elements.dialog.querySelectorAll<HTMLElement>(focusableSelector)];
    if (!items.length) return;
    const first = items[0]; const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  elements.dialog.addEventListener('click', (event) => { if (event.target === elements.dialog) close(); });
  return { open, close };
}
